import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { useTranslation } from "@/i18n/LanguageContext";

export default function ConfirmDialog({ open, onOpenChange, title, description, confirmLabel, onConfirm, destructive = false, testId = "confirm-dialog" }) {
  const t = useTranslation();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid={testId} className="border-border">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display tracking-tight">{title}</AlertDialogTitle>
          <AlertDialogDescription className="text-xs">{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testId}-cancel`} className="rounded-lg">
            {t("common.actions.cancel")}
          </AlertDialogCancel>
          <AlertDialogAction
            data-testid={`${testId}-confirm`}
            onClick={onConfirm}
            className={
              "rounded-lg " +
              (destructive
                ? "bg-destructive text-destructive-foreground hover:bg-destructive/90"
                : "")
            }
          >
            {confirmLabel || t("common.actions.confirm")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
